(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-meta"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.swiper-meta').forEach(function (slider) {
    const wrapper = slider.closest('.swiper-meta-wrapper');

    new Swiper(slider, {
      slidesPerView: 2.5,
      spaceBetween: 12,

      breakpoints: {
        320: {
          slidesPerView: 1.3,
        },
        375: {
          slidesPerView: 1.3,
        },
        425: {
          slidesPerView: 1.3,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1.9,
        },
      },

      navigation: {
        nextEl: wrapper.querySelector('.swiper-meta-next'),
        prevEl: wrapper.querySelector('.swiper-meta-prev'),
      },
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
